(function(){
	'use strict';

	angular
	.module('app')
	.directive('rdConversion', rdConversionDirective);

	function rdConversionDirective($http) {
		return {
			restrict: 'A',
			scope: false,
			link: rdConversionLink
		}

		function rdConversionLink(scope, element, attrs){
			let event = scope.$eval(attrs.rdConversion)[0];
			element.bind(event.join(' '), () => {
				let data = scope.$eval(attrs.rdConversion)[1];
				data.token_rdstation = '7bc8218f9b611dbede445435357a4e11';
				data.data_hora = (new Date()).toString();
				data.c_utmz = 'www.brastelha.ind.br';
				data.identificador = scope.$eval(attrs.rdConversion)[2];
				$http.post('http://www.rdstation.com.br/api/1.3/conversions', data);
			})
		}
	}


})();
